import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PolicyText } from './Info';
import { SocialSignInButtons } from './SignIn';
import * as ROUTES from '../constants/routes';
import { useFormInput, useSignInAuthorization } from '../hooks';
import { signUp } from '../actions';
import { getSignUpError, getSignUpFetching } from '../reducers';

export default function SignUp() {
  const displayName = useFormInput('');
  const email = useFormInput('');
  const passwordOne = useFormInput('');
  const passwordTwo = useFormInput('');
  const { t } = useTranslation();

  const error = useSelector(getSignUpError);
  const isFetching = useSelector(getSignUpFetching);

  const dispatch = useDispatch();
  function handleSubmit(event) {
    event.preventDefault();
    const user = {
      email: email.value,
      password: passwordOne.value,
      displayName: displayName.value,
    };
    dispatch(signUp(user));
  }

  const isSignedIn = useSignInAuthorization(false);
  if (isSignedIn) {
    return <Redirect to={ROUTES.VOTE} />;
  }

  const isInvalid =
    passwordOne.value !== passwordTwo.value ||
    passwordOne.value === '' ||
    email.value === '' ||
    displayName.value === '';

  return (
    <div className="container">
      <form className="form-auth" onSubmit={handleSubmit} autoComplete="off">
        <div className="text-center mb-4">
          <h1 className="h3 mb-3 font-weight-normal">
            {t('auth.signUpTitle', 'Sign Up')}
          </h1>
        </div>
        <div className="form-label-group">
          <input
            type="text"
            className="form-control"
            placeholder={t('auth.displayNamePlaceholder', 'Display name')}
            required
            autoFocus
            name="displayName"
            {...displayName}
          />
          <label htmlFor="inputEmail">
            {t('auth.displayNamePlaceholder', 'Display name')}
          </label>
        </div>
        <div className="form-label-group">
          <input
            type="email"
            className="form-control"
            placeholder={t('auth.emailPlaceholder', 'Email address')}
            required
            autoCapitalize="off"
            autoCorrect="off"
            name="email"
            {...email}
          />
          <label htmlFor="inputEmail">
            {t('auth.emailPlaceholder', 'Email address')}
          </label>
        </div>
        <div className="form-label-group">
          <input
            type="password"
            className="form-control"
            placeholder={t('auth.passwordPlaceholder', 'Password')}
            required
            name="passwordOne"
            {...passwordOne}
          />
          <label htmlFor="inputPassword">
            {t('auth.passwordPlaceholder', 'Password')}
          </label>
        </div>
        <div className="form-label-group">
          <input
            type="password"
            className="form-control"
            placeholder={t('auth.confirmPasswordPlaceholder', 'Confirm password')}
            required
            name="passwordTwo"
            {...passwordTwo}
          />
          <label htmlFor="inputPassword">
            {t('auth.confirmPasswordPlaceholder', 'Confirm password')}
          </label>
        </div>
        <button
          disabled={isInvalid}
          className="btn btn-primary btn-block"
          type="submit"
        >
          {isFetching ? (
            <>
              <span
                className="spinner-grow spinner-grow-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span className="sr-only">{t('common.loading')}</span>
            </>
          ) : (
            t('auth.signUpButton', 'Sign up')
          )}
        </button>
        <div className="text-center">
          {!isFetching && error && (
            <p className="mt-2 text-danger">{error.message}</p>
          )}
          <div className="text-center my-3">
            {t('auth.orDivider', '-or-')}
          </div>
          <SocialSignInButtons />
          <PolicyText />
        </div>
      </form>
    </div>
  );
}
